export class EncryptionHelper {

    static hexToUintArray(hex: string): Uint8Array {
        const a = [];
        for (let i = 0, len = hex.length; i < len; i += 2) {
          a.push(parseInt(hex.substr(i, 2), 16));
        }
        return new Uint8Array(a);
    }

    static hexToArrayBuf(hex: string): ArrayBuffer {
        return EncryptionHelper.hexToUintArray(hex).buffer;
    }

    static arrayBufToBase64UrlEncode(buf: ArrayBuffer): string {
        let binary = '';
        const bytes = new Uint8Array(buf);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary)
          .replace(/\//g, '_')
          .replace(/=/g, '')
          .replace(/\+/g, '-');
    }

    static jwkConv(prvHex: string, pubHex: string): JsonWebKey {
        return {
            kty: 'EC',
            crv: 'P-256',
            d: EncryptionHelper.arrayBufToBase64UrlEncode(EncryptionHelper.hexToArrayBuf(prvHex)),
            x: EncryptionHelper.arrayBufToBase64UrlEncode(EncryptionHelper.hexToArrayBuf(pubHex).slice(1, 33)),
            y: EncryptionHelper.arrayBufToBase64UrlEncode(EncryptionHelper.hexToArrayBuf(pubHex).slice(33, 66))
        };
    }

    static convertArrayBufferToHexaDecimal(buffer: ArrayBuffer): string {
        const dataView = new DataView(buffer);
        let iii;
        let len;
        let hex = '';
        let c;

        for (iii = 0, len = dataView.byteLength; iii < len; iii += 1) {
            c = dataView.getUint8(iii).toString(16);
            if (c.length < 2)
            {
                c = '0' + c;
            }

            hex += c;
        }

        return hex;
    }
}
